import { Fetch } from 'lib';

type RequestResponses = {};

type RequestParameters = {
  id: string;
};

const deleteCategory = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminCategory/deleteCategory',
    method: 'DELETE',
    params,
  });

export { deleteCategory };
